import { render, staticRenderFns } from "./DistributionTableItem.vue?vue&type=template&id=656f698a&scoped=true"
import script from "./DistributionTableItem.vue?vue&type=script&lang=js"
export * from "./DistributionTableItem.vue?vue&type=script&lang=js"
import style0 from "./DistributionTableItem.vue?vue&type=style&index=0&id=656f698a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f698a",
  null
  
)

export default component.exports